import { IMappers } from '../../../../common/repositories/price-estimator/my-home/v3/create-realty';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
import { ICreateSecondaryMyHomeV3Response } from '../../../../common/repositories/price-estimator/entities/web/CreateSecondaryMyHomeV3Response';

export const createSubmitFlatDataMapper = (): IMappers<TMappedResponse200, TMappedResponse400> => ({
  200: response => response.dataPaymentFormUrl,
  400: ({ message }) => {
    return new HttpBadStatusCodeError({
      domain: '',
      statusCode: 400,
      message: message || '',
    });
  },
});

export type TMappedResponse200 = ICreateSecondaryMyHomeV3Response['dataPaymentFormUrl'];
export type TMappedResponse400 = HttpBadStatusCodeError;
